module.exports = __webpack_public_path__ + "img/menu.d0764e52.svg";